import { createContext } from "react";
import { TNotificationType } from "./NotificationTypes";
var emptyNotifications = [];
var NotificationsContext = createContext({
    notifications: emptyNotifications,
    addNotification: function (message, type) {
        if (type === void 0) { type = TNotificationType.success; }
    },
});
export default NotificationsContext;
//# sourceMappingURL=NotificationsContext.js.map